import * as React from "react";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { CustomerType } from "../../../../../../../Wrap/Constants/Enums/Customer/CustomerType";
import { RelationshipType } from "../../../../../../../Wrap/Constants/Enums/Customer/RelationshipType";
import { HierarchyLevelName } from "../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { RoleType } from "../../../../../../../Wrap/Constants/Enums/RoleType";
import { TrustDetail } from "../../../../../../../Wrap/Models/Domains/Account/TrustDetail";
import { Organisation } from "../../../../../../../Wrap/Models/Models/Customer/Organisation";
import { OrganisationMember } from "../../../../../../../Wrap/Models/Models/Customer/OrganisationMember";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { TrustMember } from "../../../AddClient/Components/Organisation/TrustMember";
import { TrustMemeberDeclaration } from "../../../Common/ClientDetails/TrustMemberDeclaration";
import { ClientRecordAction } from "../../Action/ClientRecordAction";
import { ShareOfTrustTable } from "../../Components/TrustMember/ShareOfTrustTable";
import { TrustMemberTable } from "../../Components/TrustMember/TrustMemberTable";
import { ClientRecordTab } from "../../Resource/Contents";
import { AccountRoleStore, ClientRecordStore } from "../../Store/Variable";

interface IAddTrustMembersProps extends IProcessComponentProps {
    data: { Organisation: Organisation };
}

interface IAddTrustMembersState {
    hasTrustAccount: boolean;
    accountId: number;
    trustDetail: TrustDetail;
    showDeleteLightbox: boolean;
    deleteItemId: OrganisationMember;
}

export class AddTrustMembers extends ProcessComponent<IAddTrustMembersProps, IAddTrustMembersState> {
    constructor(props: IAddTrustMembersProps) {
        super(props);
        this.state = {
            hasTrustAccount: false,
            accountId: null,
            trustDetail: null,
            showDeleteLightbox: false,
            deleteItemId: null,
        };
        this.subscribeToStore(AccountRoleStore, () => {
            const result = (AccountRoleStore.getData() || []).filter(
                (ele) => ele.AccountRoleType == RoleType.TrustAccountHolder
            );
            if (result.length > 0) {
                this.setState({
                    hasTrustAccount: true,
                    accountId: result[0].AccountId,
                });
                this.getTrustDetail(this.getHierarchyId(result[0].AccountId));
            }
        });
    }

    componentDidMount() {
        super.componentDidMount();
        ClientRecordAction.getAccountRoleDetail(this.props.data?.Organisation?.CustomerId.toString());
    }

    private getTrustDetail(hierarchyId: string) {
        if (hierarchyId) {
            ClientRecordAction.getTrustDetails(hierarchyId, (result) => {
                this.setState({ trustDetail: result });
            });
        }
    }

    private getHierarchyId(accountId: number) {
        return HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Account, accountId);
    }

    render() {
        const { data } = this.props;
        const { hasTrustAccount, trustDetail, accountId } = this.state;
        const originalData: Organisation = ClientRecordStore.getData()?.[ClientRecordTab.OrganisationDetails];
        return (
            <>
                <h2>{data?.Organisation?.CustomerType == CustomerType.CorporateTrust ? "Name" : "Trust Name"}</h2>
                <p>{data?.Organisation?.Name}</p>
                <h2>Existing trust members</h2>
                <TrustMemberTable
                    data={(originalData.OrganisationMembers || []).filter(
                        (ele) =>
                            !ele.Relationships.includes(RelationshipType.CorporateTrustee) &&
                            !ele.Relationships.every((ele) => ele == RelationshipType.Beneficiary)
                    )}
                    isCompanyMember={false}
                    isBeneficiaryOnly={false}
                    onDelete={(id) => this.setState({ showDeleteLightbox: true, deleteItemId: id })}
                    onEdit={(id) => {}}
                    onEditRoles={(id) => {}}
                    onClickHistory={(id) => {}}
                    onClickShareofTrust={() => {}}
                    title={"Individual members"}
                    showShareOfTrust={false}
                />
                <br />
                <TrustMemberTable
                    data={(originalData?.OrganisationMembers || []).filter((ele) =>
                        ele.Relationships.includes(RelationshipType.CorporateTrustee)
                    )}
                    isCompanyMember={true}
                    isBeneficiaryOnly={false}
                    onDelete={(id) => this.setState({ showDeleteLightbox: true, deleteItemId: id })}
                    onEdit={(id) => {}}
                    onEditRoles={(id) => {}}
                    onClickHistory={(id) => {}}
                    onClickShareofTrust={() => {}}
                    title={"Corporate members"}
                    showShareOfTrust={false}
                />
                <hr />
                <TrustMember
                    {...this.props}
                    onPrevious={() => {}}
                    onSubmit={() => {}}
                    onlyTrustMember
                    existingMembers={originalData?.OrganisationMembers || []}
                    onRef={(ref) => this.appendChild(ref)}
                    disableBeneficiaryOption={hasTrustAccount && trustDetail?.TrustCategory == "Absolute"}
                    disableSettlorOption={hasTrustAccount}
                    disableCorporateTrusteeOption={originalData?.OrganisationMembers?.some((x) =>
                        x?.Relationships.includes(RelationshipType.CorporateTrustee)
                    )}
                />
                <hr />

                {hasTrustAccount &&
                    !CommonHelper.isNullOrEmpty(data?.Organisation?.OrganisationMembers) &&
                    data?.Organisation?.OrganisationMembers.some(
                        (x) => x.Relationships.includes(RelationshipType.Beneficiary) && x?.CustomerId > 0
                    ) && (
                        <ShareOfTrustTable
                            data={null}
                            organisation={data?.Organisation}
                            deletedBeneficiary={null}
                            remainingBeneficiaries={originalData?.OrganisationMembers.filter((x) =>
                                x.Relationships.includes(RelationshipType.Beneficiary)
                            )}
                            isAddBeneficiary={true}
                            IsAddAdditionalBeneficiary={false}
                            onChange={(Organisation) => this.props.onChange({ Organisation })}
                            accountId={accountId}
                            onRef={(ref) => this.appendChild(ref)}
                            showErrorMsgPopUp={(msg, now) => this.props.showErrorMsgPopUp(msg, now)}
                        />
                    )}
                <TrustMemeberDeclaration />
            </>
        );
    }
}
